import type { FC } from 'react'
import React from 'react'

import type { IconGooglePlayWhiteProps } from './IconGooglePlayWhite.types'
import * as Styled from './styles/IconGooglePlayWhite.style'

import { nonThemeableRules } from '../../ruleSet'

const IconGooglePlayWhite: FC<IconGooglePlayWhiteProps> = ({
  size = nonThemeableRules.defaultSize as number as IconGooglePlayWhiteProps['size'],
  isResponsive = false,
}: IconGooglePlayWhiteProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M10 42c0-11.201 0-16.802 2.18-21.08a19.999 19.999 0 0 1 8.74-8.74C25.198 10 30.8 10 42 10h36c11.201 0 16.802 0 21.08 2.18a19.997 19.997 0 0 1 8.74 8.74C110 25.198 110 30.8 110 42v36c0 11.201 0 16.802-2.18 21.08a19.995 19.995 0 0 1-8.74 8.74C94.802 110 89.2 110 78 110H42c-11.201 0-16.802 0-21.08-2.18a19.997 19.997 0 0 1-8.74-8.74C10 94.802 10 89.2 10 78V42Z'
          fill='#fff'
        />
        <path
          d='M49.32 86.316c-1.684 0-3.056 1.28-3.056 3.043 0 1.753 1.372 3.044 3.055 3.044 1.684 0 3.055-1.292 3.055-3.044 0-1.763-1.371-3.043-3.055-3.043Zm0 4.888c-.923 0-1.719-.761-1.719-1.845 0-1.095.796-1.845 1.718-1.845.922 0 1.718.75 1.718 1.845 0 1.085-.795 1.845-1.718 1.845Zm8.18-4.208h-.045c-.3-.358-.877-.68-1.603-.68-1.522 0-2.917 1.337-2.917 3.055 0 1.707 1.395 3.033 2.917 3.033.726 0 1.303-.323 1.603-.692h.046v.438c0 1.164-.623 1.787-1.626 1.787-.819 0-1.326-.588-1.533-1.084l-1.165.485c.334.807 1.222 1.799 2.698 1.799 1.568 0 2.894-.923 2.894-3.171V86.5h-1.268v.496Zm-1.532 4.208c-.923 0-1.696-.773-1.696-1.833 0-1.072.773-1.857 1.696-1.857.91 0 1.625.784 1.625 1.857 0 1.061-.715 1.833-1.625 1.833Zm-13.314-4.888c-1.684 0-3.056 1.28-3.056 3.043 0 1.753 1.372 3.044 3.056 3.044 1.683 0 3.055-1.292 3.055-3.044 0-1.763-1.372-3.043-3.055-3.043Zm0 4.888c-.923 0-1.718-.761-1.718-1.845 0-1.095.795-1.845 1.718-1.845.922 0 1.717.75 1.717 1.845 0 1.085-.795 1.845-1.717 1.845Zm-7.93-3.954v1.291h3.09c-.091.726-.333 1.257-.703 1.626-.45.45-1.153.946-2.387.946-1.902 0-3.39-1.533-3.39-3.436s1.488-3.437 3.39-3.437c1.026 0 1.776.404 2.33.923l.91-.911c-.773-.738-1.798-1.303-3.24-1.303-2.606 0-4.796 2.122-4.796 4.728 0 2.605 2.19 4.727 4.796 4.727 1.407 0 2.467-.462 3.298-1.326.853-.853 1.119-2.053 1.119-3.021 0-.3-.024-.577-.07-.807h-4.347Zm32.427 1.003c-.254-.68-1.026-1.937-2.605-1.937-1.569 0-2.871 1.234-2.871 3.044 0 1.706 1.292 3.044 3.02 3.044 1.396 0 2.203-.853 2.538-1.35l-1.038-.691c-.346.507-.819.84-1.5.84-.68 0-1.164-.31-1.474-.921l4.07-1.684-.14-.345Zm-4.15 1.014c-.034-1.176.91-1.775 1.59-1.775.531 0 .98.265 1.13.646l-2.72 1.13Zm-3.31 2.952h1.338v-8.947h-1.338v8.947Zm13.726-8.947h-3.2v8.947h1.335v-3.39h1.864c1.48 0 2.936-1.071 2.936-2.778s-1.455-2.78-2.935-2.78Zm.034 4.312h-1.9v-3.067h1.9c.998 0 1.566.827 1.566 1.533 0 .694-.568 1.534-1.566 1.534Zm3.638 4.635h1.334v-8.947h-1.335v8.947Zm4.615-5.92c-.966 0-1.968.426-2.382 1.37l1.185.495c.253-.495.725-.656 1.22-.656.691 0 1.393.415 1.405 1.151v.092a2.956 2.956 0 0 0-1.393-.345c-1.277 0-2.578.703-2.578 2.014 0 1.197 1.048 1.968 2.221 1.968.898 0 1.393-.402 1.704-.874h.046v.69h1.289v-3.43c0-1.588-1.186-2.475-2.717-2.475Zm-.161 4.904c-.438 0-1.048-.219-1.048-.76 0-.69.76-.955 1.416-.955.587 0 .863.127 1.22.299a1.619 1.619 0 0 1-1.588 1.416Zm7.574-4.708-1.531 3.88h-.046l-1.588-3.88h-1.439l2.383 5.421-1.358 3.016h1.392l3.672-8.437h-1.485Z'
          fill='#000'
          opacity='.54'
        />
        <path
          d='M40.627 28.098c-.538.57-.856 1.453-.856 2.598V71.59c0 1.146.318 2.028.856 2.598l.137.133 22.908-22.908v-.54l-22.908-22.91-.137.135Z'
          fill='url(#a666281d-ad63-4dc9-bc09-0fe085bf29d3__a)'
        />
        <path
          d='m71.308 59.052-7.636-7.639v-.54l7.637-7.638.172.098 9.048 5.14c2.584 1.47 2.584 3.871 0 5.34l-9.048 5.141-.173.098Z'
          fill='url(#a666281d-ad63-4dc9-bc09-0fe085bf29d3__b)'
        />
        <path
          d='m71.481 58.953-7.81-7.81-23.044 23.045c.852.901 2.258 1.013 3.843.113l27.01-15.348Z'
          fill='url(#a666281d-ad63-4dc9-bc09-0fe085bf29d3__c)'
        />
        <path
          d='M71.481 43.332 44.47 27.984c-1.585-.9-2.99-.788-3.843.114l23.045 23.045 7.81-7.81Z'
          fill='url(#a666281d-ad63-4dc9-bc09-0fe085bf29d3__d)'
        />
        <path
          d='m71.31 58.781-26.84 15.25c-1.502.853-2.844.796-3.705.02l-.138.138.137.133c.862.776 2.204.833 3.706-.02l27.01-15.35-.172-.172Z'
          fill='#000'
          opacity='.2'
        />
        <path
          d='M40.627 73.918c-.538-.569-.856-1.452-.856-2.597v.27c0 1.145.318 2.028.856 2.598l.138-.138-.138-.133Zm39.901-20.376-9.219 5.24.172.171 9.047-5.14c1.292-.734 1.939-1.702 1.939-2.67-.109.875-.767 1.734-1.939 2.4Z'
          fill='#000'
          opacity='.12'
        />
        <path
          d='m44.47 28.256 36.059 20.487c1.171.666 1.829 1.523 1.938 2.4 0-.968-.646-1.936-1.938-2.67l-36.06-20.488c-2.584-1.468-4.698-.248-4.698 2.712v.27c0-2.96 2.114-4.18 4.699-2.711Z'
          fill='#fff'
          opacity='.25'
        />
        <defs>
          <linearGradient
            id='a666281d-ad63-4dc9-bc09-0fe085bf29d3__a'
            gradientUnits='userSpaceOnUse'
            x1='61.641'
            x2='30.608'
            y1='30.265'
            y2='61.296'
          >
            <stop stopColor='#00A0FF' />
            <stop offset='.007' stopColor='#00A1FF' />
            <stop offset='.26' stopColor='#00BEFF' />
            <stop offset='.512' stopColor='#00D2FF' />
            <stop offset='.76' stopColor='#00DFFF' />
            <stop offset='1' stopColor='#00E3FF' />
          </linearGradient>
          <linearGradient
            id='a666281d-ad63-4dc9-bc09-0fe085bf29d3__b'
            gradientUnits='userSpaceOnUse'
            x1='83.893'
            x2='39.151'
            y1='51.144'
            y2='51.144'
          >
            <stop stopColor='#FFE000' />
            <stop offset='.409' stopColor='#FFBD00' />
            <stop offset='.775' stopColor='orange' />
            <stop offset='1' stopColor='#FF9C00' />
          </linearGradient>
          <linearGradient
            id='a666281d-ad63-4dc9-bc09-0fe085bf29d3__c'
            gradientUnits='userSpaceOnUse'
            x1='67.238'
            x2='25.156'
            y1='55.387'
            y2='97.469'
          >
            <stop stopColor='#FF3A44' />
            <stop offset='1' stopColor='#C31162' />
          </linearGradient>
          <linearGradient
            id='a666281d-ad63-4dc9-bc09-0fe085bf29d3__d'
            gradientUnits='userSpaceOnUse'
            x1='34.825'
            x2='53.616'
            y1='14.486'
            y2='33.277'
          >
            <stop stopColor='#32A071' />
            <stop offset='.069' stopColor='#2DA771' />
            <stop offset='.476' stopColor='#15CF74' />
            <stop offset='.801' stopColor='#06E775' />
            <stop offset='1' stopColor='#00F076' />
          </linearGradient>
        </defs>
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconGooglePlayWhite
